import React, { useEffect, useState } from "react";
import { fetchData } from "../../Cpanel/Components/Utilities";
import Cat1 from "../../Assets/images/563715630260656128.png";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
// import { useHistory } from "react-router-dom";
const ProductSlider = () => {
  // const history = useHistory();
  const [products, setProducts] = useState([]);
  useEffect(() => {
    // offlinebodyFormData.append("type", 2);
    // fetchData("shoplist", onlinebodyFormData, handleOnlineApiResponse);
    fetchData("getproduct", {}, handleApiResponse);
    // handleApiResponse([
    //   { id: 1, name: "نان وغلات", img: Cat1 },
    //   { id: 1, name: "نان وغلات", img: Cat1 },
    //   { id: 1, name: "نان وغلات", img: Cat1 },
    //   { id: 1, name: "نان وغلات", img: Cat1 },
    //   { id: 1, name: "نان وغلات", img: Cat1 },
    //   { id: 1, name: "نان وغلات", img: Cat1 },
    //   { id: 1, name: "نان وغلات", img: Cat1 },
    // ]);
  }, []);
  console.log(products);
  const handleApiResponse = (data) => {
    const productList = data?.data?.filter((product) => product?.status != 0);
    setProducts(productList);
  };

  const navigate = useNavigate();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3.5,
    slidesToScroll: 1.5,
    swipeToSlide: true,
    swipeToSlide: true,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000, // Set autoplay speed in milliseconds

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3.5,
          infinite: true,
          // dots: true
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2.5,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 2,
        },
      },
    ],
  };

  const sliderRef = React.useRef();
  const handleProductClick = (product) => {
    navigate(`/product/${product?.id}`, { state: { product: product } });
  };
  const handleBuyProduct = (product) => {
    navigate(`/buyproduct`, { state: { product } });
  };
  const renderCategory = (product) => {
    // Filter online or local shops based on the selected category
    // const filteredShops =
    //   activeTab === "online"
    //     ? onlineShops?.dt?.filter((shop) => shop?.category === product?.name)
    //     : localShops?.dt?.filter((shop) => shop?.category === product?.name);
    return (
      <>
        <div
          key={product.id}
          className="category-item  cursor-pointer product-card"
        >
          <img
            onClick={() => handleProductClick(product)}
            src={`https://api.taab30.com${product?.pic}`}
            alt={product?.title}
            className="category-icon  product-card-img"
          />
          <div className="category-name ">{product?.title}</div>

          <p dir="rtl" className="product-price">
            {" "}
            {product?.price?.toLocaleString("en-US", {
              style: "decimal",
              maximumFractionDigits: 0,
            })}
           <span className="fs-6"> تومان</span>
          </p>
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm px-3 text-white  btn-orange"
              onClick={() =>
                navigate("/buyproductform", { state: { product: product } })
              }
            >
              خرید
            </button>
            <button
              className="btn btn-sm   btn-info"
              onClick={() => handleProductClick(product)}
            >
              مشاهده
            </button>
          </div>
          {/* Display the number of shops in the category */}
          {/* <div>{filteredShops?.length} shops</div> */}
        </div>

        {/* <div className="col-span-12 lg:col-span-8">
          <Slider
            {...settings}
            className="active:outlin-none"
           
          >
            {products?.map((slider, index) => (
              <div key={index} className="w-full">
                <img
                  src={slider?.img}
                  alt={slider?.title}
                  className="rounded-2xl w-full h-full"
                />
              </div>
            ))}
          </Slider>
        </div> */}
      </>
    );
  };

  return (
    <div>
      <div className="card p-2 bg-light">
        <Slider ref={sliderRef} {...settings}>
          {products?.map((category) => renderCategory(category))}
        </Slider>
      </div>
    </div>
  );
};

export default ProductSlider;
